import axiosClient from "./axiosClient";

const videoApi = {
  uploadVideo: async (data: any) => {
    const res = await axiosClient.post(`/videos`, data);
    return res;
  },
  getVideos: async () => {
    const res = await axiosClient.get(`/videos`);
    return res;
  },
  getVideosBySubject: async (id: number) => {
    const res = await axiosClient.get(`/subjects/${id}/videos`);
    return res;
  },
  deleteVideo: async (id: number) => {
    const res = await axiosClient.delete(`/videos/${id}`);
    return res;
  }
};

export default videoApi;
